export default [uiStateManagerServiceTestingData]

const SAMPLE_SIZE = 250
const randomChoice = function randomChoice(arr) {
  return arr[Math.floor(Math.random() * arr.length)]
}
// const randomRange = function randomRange (start, stop) {
//   return Math.floor(Math.random() * stop) + start;
// }
const inflateBufferedRequestsForTest = function inflateBufferedRequestsForTest() {
  return {
    stateName: randomChoice(['alpha', 'revisions', 'bravo', 'charlie']),
    state: randomChoice(['active', 'disabled']),
    payload: randomChoice([
      { awesome: 'sauce' },
      { awesome: 'sauce', ok: 'go' },
      { might: 'bean' },
      {},
    ]),
    priority: randomChoice([100, 101, 102, 103, 104]),
    sender: {
      name: randomChoice(['alpha', 'bravo', 'charlie']),
    },
    action: randomChoice([{}, 'aoeu', ['ueoa']]),
  }
}
function uiStateManagerServiceTestingData() {
  this.obtainSampleDataSet = function obtainSampleDataSet() {
    const sampleDataSet = []
    for (let cdx = 0; cdx < SAMPLE_SIZE; cdx++) {
      sampleDataSet.push(inflateBufferedRequestsForTest())
    }
    return sampleDataSet
  }
}
